import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { logger } from 'redux-logger';
import { persistStore, persistReducer } from 'redux-persist';
import rootReducer from './reducers';
import localStorage from 'redux-persist/es/storage';

// const persistConfig = {
//     key: 'root',
//     storage: localStorage
// };

const initialState = {};

const middleware = [thunk //, logger
];

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(...middleware)));

// export const persistor = persistStore(store);